export const HOME = {
  emergentLink: "home-emergent-link",
};

export const LANDING = {
  navLogo: "nav-logo",
  navAbout: "nav-about-link",
  navServices: "nav-services-link",
  navGallery: "nav-gallery-link",
  navContact: "nav-contact-link",
  navBookCta: "nav-book-cta",
  heroBookBtn: "hero-book-btn",
  heroScrollHint: "hero-scroll-hint",
  aboutSection: "about-section",
  servicesSection: "services-section",
  serviceCard: "service-card",
  gallerySection: "gallery-section",
  testimonialsSection: "testimonials-section",
  contactSection: "contact-section",
  contactMailto: "contact-mailto-link",
  contactInstagram: "contact-instagram-link",
  contactFacebook: "contact-facebook-link",
  footer: "footer",
};
